import { Typography, withStyles } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import React, { useRef } from "react";
import { TableDataTransaction } from "../../containers/ComptePage/helpers";
import { ErrorApi } from "../../types";
import LoadingBoundary from "../LoadingBoundary";
import { HeadCell } from "./helpers";
import styles from "./styles";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";

interface Props {
  rows?: TableDataTransaction[];
  headCells: HeadCell[];
  classes?: any;
  fetchingTable?: boolean;
  errorTable?: ErrorApi;
}

export type Order = "asc" | "desc";
function EnhancedTable(props: Props) {
  const { rows, headCells, classes, fetchingTable, errorTable } = props;

  const ref = useRef<HTMLHeadingElement>(null);
  return (
    <div>
      <TableContainer className={classes.tableContainer} ref={ref}>
        <Table
          aria-labelledby="tableTitle"
          aria-label="enhanced table"
          className={classes.table}
          stickyHeader
        >
          <TableHeader headCells={headCells} />
          <LoadingBoundary
            loading={fetchingTable}
            error={errorTable}
            table={true}
          >
            <TableBody>
              {rows &&
                rows.length > 0 &&
                rows.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      key={row.detail + index}
                      headCells={headCells}
                      row={row}
                      labelId={labelId}
                    />
                  );
                })}

              {(!rows || rows.length === 0) && !fetchingTable && (
                <td colSpan={7}>
                  <Typography variant="h5" align="center">
                    Aucun résultat
                  </Typography>
                </td>
              )}
            </TableBody>
          </LoadingBoundary>
        </Table>
      </TableContainer>
    </div>
  );
}
export default withStyles(styles)(EnhancedTable);
